/**
 * Tiny event bridge between the "Cookie settings" button (rendered on /legal,
 * outside the consent context) and the lazily-loaded consent system.
 */

export const COOKIE_SETTINGS_EVENT = 'vs:open-cookie-settings';

let pendingRequest = false;

/** Ask the consent system to open its preferences dialog, loading it first if needed. */
export function requestCookieSettings() {
  pendingRequest = true;
  window.dispatchEvent(new Event(COOKIE_SETTINGS_EVENT));
}

/** Consumed by the consent system on mount to honor a click that arrived before it loaded. */
export function consumePendingCookieSettingsRequest() {
  const was = pendingRequest;
  pendingRequest = false;
  return was;
}
